import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { CategoryHistoryRes } from 'features/categories/types/categories.types'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

export const useFetchCategoryHistory = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: categoryHistory, isPending: isCategoryLoading } = useQuery<CategoryHistoryRes>({
		queryKey: queryKeys.categories.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.categoryHistory(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		categoryHistory,
		isCategoryLoading
	}
}
